import { Text } from '@libs/ui/ds'
import classnames from 'classnames'
import Immutable from 'immutable'

import styles from './ModalTooltip.module.css'

const modulationInfos = t => {
  return Immutable.OrderedMap({
    minus: {
      id: 'minus',
      title: t('counterModulation.infos.minus.title'),
      content: t('counterModulation.infos.minus.content')
    },
    maximum: {
      id: 'maximum',
      title: t('counterModulation.infos.maximum.title'),
      content: t('counterModulation.infos.maximum.content')
    },
    total_limit_worked_hours: {
      id: 'total_limit_worked_hours',
      title: t('counterModulation.infos.totalLimitWorkedHours.title'),
      content: t('counterModulation.infos.totalLimitWorkedHours.content')
    },
    hours_to_work_to_date: {
      id: 'hours_to_work_to_date',
      title: t('counterModulation.infos.hoursToWorkToDate.title'),
      content: t('counterModulation.infos.hoursToWorkToDate.content')
    },
    total_hours_worked_over_period: {
      id: 'total_hours_worked_over_period',
      title: t('counterModulation.infos.totalHoursWorkedOverPeriod.title'),
      content: t('counterModulation.infos.totalHoursWorkedOverPeriod.content')
    },
    hour_performed: {
      id: 'hour_performed',
      title: t('counterModulation.infos.hourPerformed.title'),
      content: (
        <>
          <Text as='p' size='m' className={styles.ContentText}>
            {t('counterModulation.infos.hourPerformed.content1')}
          </Text>
          <Text as='p' size='m' className={styles.ContentText}>
            {t('counterModulation.infos.hourPerformed.content2')}
          </Text>
          <Text as='p' size='m' className={styles.ContentText}>
            {t('counterModulation.infos.hourPerformed.content3')}
          </Text>
        </>
      )
    },
    modulation_gap: {
      id: 'modulation_gap',
      title: t('counterModulation.infos.modulationGap.title'),
      content: (
        <ul>
          <li className={styles.ListItem}>
            <Text as='p' size='m' className={styles.ContentText}>
              {t('counterModulation.infos.modulationGap.content1')}
            </Text>
            <Text as='p' size='m' className={styles.ContentSubText}>
              {t('counterModulation.infos.modulationGap.content2')}
            </Text>
          </li>
          <li className={styles.ListItem}>
            <Text as='p' size='m' className={styles.ContentText}>
              {t('counterModulation.infos.modulationGap.content3')}
            </Text>
            <Text as='p' size='m' className={styles.ContentSubText}>
              {t('counterModulation.infos.modulationGap.content4')}
            </Text>
          </li>
          <li className={styles.ListItem}>
            <Text as='p' size='m' className={styles.ContentText}>
              {t('counterModulation.infos.modulationGap.content5')}
            </Text>
            <li
              className={classnames(styles.ListSubItem, styles.ContentSubText)}
            >
              <Text as='p' size='m' className={styles.ContentText}>
                {t('counterModulation.infos.modulationGap.content6')}
              </Text>
            </li>
            <Text as='p' size='m' className={styles.ContentSubText}>
              {t('counterModulation.infos.modulationGap.content7')}
            </Text>
            <li
              className={classnames(styles.ListSubItem, styles.ContentSubText)}
            >
              <Text as='p' size='m' className={styles.ContentText}>
                {t('counterModulation.infos.modulationGap.content8')}
              </Text>
            </li>
            <Text as='p' size='m' className={styles.ContentSubText}>
              {t('counterModulation.infos.modulationGap.content9')}
            </Text>
            <Text as='p' size='m' className={styles.ContentText}>
              {t('counterModulation.infos.modulationGap.content10')}
            </Text>
          </li>
        </ul>
      )
    },
    cumul: {
      id: 'cumul',
      title: t('counterModulation.infos.cumul.title'),
      content: t('counterModulation.infos.cumul.content')
    },
    overtime_hours: {
      id: 'overtime_hours',
      title: t('counterModulation.infos.overtimeHours.title'),
      content: t('counterModulation.infos.overtimeHours.content')
    },
    absence: {
      id: 'absence',
      title: t('counterModulation.infos.absence.title'),
      content: t('counterModulation.infos.absence.content')
    }
  })
}

export default modulationInfos
